export function getSSORedirectUrl(config, targetApi = false) {
  const urlSearch = window.location.search

  const params = new URLSearchParams(urlSearch)

  if (params.has('client_id') && params.has('redirect_uri')) {
    return `authorize${targetApi ? '/v2' : ''}${urlSearch}`
  } else {
    if (!config || !config.sso || !config.sso.clientId || !config.sso.redirectUrl) {
      return '/'
    } else {
      return `authorize${targetApi ? '/v2' : ''}${buildSSOParams(
        config.sso.clientId,
        config.sso.redirectUrl,
      )}`
    }
  }
}

function buildSSOParams(clientId, redirectUrl) {
  return `?response_type=code&scope=openid&client_id=${clientId}&redirect_uri=${redirectUrl}`
}
